module.exports = __webpack_public_path__ + "fonts/la-regular-400.88d9d94.woff2";